
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/general-conditions",
      function () {
        return require("private-next-pages/general-conditions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/general-conditions"])
      });
    }
  